<template>
  <div>
    <!-- begin row -->
    <div class="row row-space-10">
      <!-- begin col-6 -->
      <div class="col-lg-6 col-md-6">
        <!-- begin card -->
        <div
          class="card border-0 text-truncate mb-3"
          :class="{ 'bg-dark text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b class="mb-3">QUOTATION STATISTIC</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Quotation Statistic"
                  v-b-popover.hover="
                    'Percentage of sessions that resulted in orders from total number of sessions.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
            <!-- begin conversion-rate -->
            <div class="d-flex align-items-center mb-1">
              <h2
                class="mb-2"
                :class="inverseMode ? 'text-white' : 'ts-text-gray-700'"
              >
                {{ total }}
              </h2>
            </div>
            <!-- end conversion-rate -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-info f-s-8 mr-2"></i>
                Pending
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{ ((pending / total) * 100) | format_number }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ pending }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-primary f-s-8 mr-2"></i>
                Confirmed
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{ ((confirmed / total) * 100) | format_number }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ confirmed }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-lime f-s-8 mr-2"></i>
                Completed
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{ ((completed / total) * 100) | format_number }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ completed }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                Incomplete
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{ ((incomplete / total) * 100) | format_number }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ incomplete }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-6 -->
      <!-- begin col-6 -->
      <div class="col-lg-6 col-md-6">
        <!-- begin card -->
        <div
          class="card border-0 text-truncate mb-3"
          :class="{ 'bg-dark text-white': inverseMode }"
        >
          <!-- begin card-body -->
          <div class="card-body">
            <!-- begin title -->
            <div class="mb-3 text-grey">
              <b class="mb-3">SALE CONTRACT STATISTIC</b>
              <span class="ml-2"
                ><i
                  class="fa fa-info-circle"
                  title="Sale Contract Statistic"
                  v-b-popover.hover="
                    'Percentage of sessions that resulted in orders from total number of sessions.'
                  "
                ></i
              ></span>
            </div>
            <!-- end title -->
            <!-- begin conversion-rate -->
            <div class="d-flex align-items-center mb-1">
              <h2
                class="mb-2"
                :class="inverseMode ? 'text-white' : 'ts-text-gray-700'"
              >
                {{ saleContractTotal }}
              </h2>
            </div>
            <!-- end conversion-rate -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-info f-s-8 mr-2"></i>
                Pending
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{
                    ((saleContractPending / saleContractTotal) * 100)
                      | format_number
                  }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ saleContractPending }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-primary f-s-8 mr-2"></i>
                Confirmed
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{
                    ((saleContractConfirmed / saleContractTotal) * 100)
                      | format_number
                  }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ saleContractConfirmed }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex mb-2">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-lime f-s-8 mr-2"></i>
                Completed
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{
                    ((saleContractCompleted / saleContractTotal) * 100)
                      | format_number
                  }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ saleContractCompleted }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
            <!-- begin info-row -->
            <div class="d-flex">
              <div class="d-flex align-items-center">
                <i class="fa fa-circle text-red f-s-8 mr-2"></i>
                Incomplete
              </div>
              <div class="d-flex align-items-center ml-auto">
                <div class="text-grey f-s-11">
                  <i class="fa fa-caret-up"></i>
                  {{
                    ((saleContractIncomplete / saleContractTotal) * 100)
                      | format_number
                  }}%
                </div>
                <div class="width-50 text-right pl-2 f-w-600">
                  {{ saleContractIncomplete }}
                </div>
              </div>
            </div>
            <!-- end info-row -->
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col-6 -->
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  props: ['inverseMode'],
  data () {
    return {
      loading: false,
      resources: null,
      saleContractResources: null
    }
  },
  filters: {
    format_number (value) {
      if (value) {
        return `${parseFloat(value).toLocaleString()}`
      }
      return 0
    }
  },
  computed: {
    pending () {
      if (this.resources) {
        return this.resources.pending
      }
      return 0
    },
    confirmed () {
      if (this.resources) {
        return this.resources.confirmed
      }
      return 0
    },
    completed () {
      if (this.resources) {
        return this.resources.completed
      }
      return 0
    },
    incomplete () {
      if (this.resources) {
        return this.resources.incomplete
      }
      return 0
    },
    total () {
      return this.pending + this.confirmed + this.completed + this.incomplete
    },
    saleOrderPending () {
      if (this.resources) {
        return this.resources.pending
      }
      return 0
    },
    saleOrderCompleted () {
      if (this.resources) {
        return this.resources.completed
      }
      return 0
    },
    saleOrderIncomplete () {
      if (this.resources) {
        return this.resources.incomplete
      }
      return 0
    },
    saleOrderTotal () {
      return (
        this.saleOrderPending +
        this.saleOrderCompleted +
        this.saleOrderIncomplete
      )
    },
    saleContractPending () {
      if (this.saleContractResources) {
        return this.saleContractResources.pending
      }
      return 0
    },
    saleContractConfirmed () {
      if (this.saleContractResources) {
        return this.saleContractResources.confirmed
      }
      return 0
    },
    saleContractCompleted () {
      if (this.saleContractResources) {
        return this.saleContractResources.completed
      }
      return 0
    },
    saleContractIncomplete () {
      if (this.saleContractResources) {
        return this.saleContractResources.incomplete
      }
      return 0
    },
    saleContractTotal () {
      return (
        this.saleContractPending +
        this.saleContractConfirmed +
        this.saleContractCompleted +
        this.saleContractIncomplete
      )
    }
  },
  methods: {
    ...mapActions('dashboard/widget', [
      'fetchQuotationStatistic',
      'fetchSaleContractStatistic'
    ]),
    moment,
    async fetchData () {
      this.loading = true
      await this.fetchQuotationStatistic()
        .then(responses => {
          this.resources = responses
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
      this.fetchSaleContractStatistic()
        .then(responses => {
          this.saleContractResources = responses
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    }
  }
}
</script>
